import $ from 'jquery';

function SoundCtrl() {
	this.$win          = $(window);
	this.$body         = $('body');
	this.$target       = $('.play-sound');
	this.$onoff        = this.$target.find('.onoff');
	this.$audioSource  = $('.audio-data').find('audio');
	this.audioSource   = this.$audioSource.get(0);
	this.$visual       = $('#homeVisual');
	this.$visualHeight = this.$visual.height();
	this.$loader       = $('#mediaLoader');

	this.storage     = window.sessionStorage;
	this.storageName = 'audioAutoFlag';

	this.currentTime = 0;

	this.load   = this.load.bind(this);
	this.setup  = this.setup.bind(this);
	this.play   = this.play.bind(this);
	this.pause  = this.pause.bind(this);
	this.remove = this.remove.bind(this);
	this.add    = this.add.bind(this);

	this.init();
}

SoundCtrl.prototype.init = function() {
	if (typeof this.audioSource === 'undefined') {
		this.$target.remove();
		return;
	}
	this.$win.on('load', this.load);
	this.$target.on('click', this.setup);
	$('.audio-on').on('click', this.play);
	$('.audio-off').on('click', this.pause);
	$('.btn-video-check').on('click', this.remove);
	$('.popup-link-video').on('click', this.pause);

	const self = this;
	this.$win.on('scroll.soundButtonScroll', function() {
		let height = self.$win.height();
		let top = $(this).scrollTop();
		if (height - 168 < top) {
			$('.btn-sound').addClass('is-scroll');
		} else {
			$('.btn-sound').removeClass('is-scroll');
		}
	})
}

SoundCtrl.prototype.load = function() {
	let audio = this.audioSource;

	if (typeof audio === 'undefined') return;

	audio.load();
	audio.muted = false;

	let mute = (this.storage.getItem('muted') === 'off') ? false : true;
	const promise = audio.play();

	if (this.storage.getItem('audioplay') !== null) {
		this.pause();
		this.remove();
		return;
	}

	if (promise !== undefined) {
		promise.catch(error => {
			audio.muted = true;
			audio.pause();
			audio.currentTime = 0;
			this.pause();
			this.add();
		}).then(() => {
			// this.remove();
			if (this.$target.hasClass('is-stoped')) {
				this.pause();
			} else {
				this.play();
			}
		});
	} else {
		this.remove();
	}
}

SoundCtrl.prototype.setup = function() {
	let audio = this.audioSource;

	if (typeof audio === 'undefined') return;

	if (audio.paused === true) {
		this.play();
	} else {
		this.pause();
	}
}

SoundCtrl.prototype.play = function() {
	this.audioSource.muted = false;
	this.audioSource.play();
	this.$target.removeClass('is-stoped').addClass('is-played');
	this.$onoff.text('ON');
	this.storage.setItem('audioplay', 'on');
}

SoundCtrl.prototype.pause = function() {
	this.audioSource.muted = true;
	this.audioSource.pause();
	this.$target.removeClass('is-played').addClass('is-stoped');
	this.$onoff.text('OFF');
	this.storage.setItem('audioplay', 'off');
}

SoundCtrl.prototype.remove = function() {
	$('html,body').css({
		overflow: '',
		position: '',
		top: ''
	});
	this.$loader.remove();
}

SoundCtrl.prototype.add = function() {
	$('html,body').css({
		overflow: 'hidden',
		position: 'fixed',
		top: 0
	});
	this.$loader.addClass('not-autoplay');
}

export default SoundCtrl;